import { render, staticRenderFns } from "./OtherNotes.vue?vue&type=template&id=9ce2a4d2"
import script from "./OtherNotes.vue?vue&type=script&lang=js"
export * from "./OtherNotes.vue?vue&type=script&lang=js"
import style0 from "./OtherNotes.vue?vue&type=style&index=0&id=9ce2a4d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports